export const armor = [
    {
    name: "Padded Clothing",
    type: "clothing",
    armorBonus: "1",
    maxDex: "-",
    armorCheck: "-",
    rarity:"none",
    hardness:0
    },
    {
    name: "Red Headband",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    rarity:"none",
    special:"Gain +1 to attack and +2 damage when making a strike, double this bonus if you're using the proper discipline weapon.",
    },
    {
    name: "Sunglasses",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    rarity:"none",
    special:"Gain +2 bonus on saves to resist gaze attacks and blindness (+5 if both), immunity to dazzle, and reduce all damage you take from light spells and effects by 1. Reduce the distance of your vision in dim light and darkness by 10 feet."
    },
    {
    name: "Wrestling Leotard",
    type: "clothing",
    armorBonus: "1",
    hardness:0,
    maxDex: "8",
    armorCheck: "-2",
    special:"Gain +4 to your CMB for grapple attempts, and a +4 CMD.",
    rarity:"none",
    },        
    {
    name: "Runecarved Robes",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"The wearer can cast a single buff typed spell into this armor, that buff's duration becomes permanent (even staying between floors) as long as you are wearing this clothing, but you receive a penalty to your armor class equal to the level of the spell cast. If the spell is dispelled or expended, it must be cast into this armor again. This spell must have a duration of at least level/2 rounds.",
    rarity:"none",
    },
    {
    name: "Dancing Scarves",
    type: "clothing",
    armorBonus: "3",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"This armor provides no bonus to AC or any other enchantment on it unless you move at least 10 feet on your turn.",
    rarity:"none",
    },
    {
    name: "Shield Arm",
    type: "clothing",
    armorBonus: "0",
    hardness:10,
    maxDex: "-",
    armorCheck: "-",
    special:"While wearing the shield arm you can equip and unequip a shield as a free action. You get a -2 penalty to attacks in a round you use the shield arm.",
    rarity:"none",
    },
    {
    name: "Bubble Wrap",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "1",
    armorCheck: "-4",
    special:"Instead of gaining armor from Bubble Wrap, you gain Gain DR/piercing, and also -10 penalty to stealth.",
    rarity:"none",
    },
    {
    name: "Focusing Headband",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"Gain a +2 resistance bonus to all saves. Once per day you can reroll a failed save.",
    rarity:"none",
    },
    {
    name: "Under Armour",
    type: "clothing",
    armorBonus: "2",
    hardness:0,
    maxDex: "5",
    armorCheck: "-2",
    rarity:"none",
    },
    {
    name: "Roxers",
    type: "clothing",
    armorBonus: "4",
    hardness:8,
    maxDex: "0",
    armorCheck: "-6",
    rarity:"none",
    special:"Your movement speed is reduced by 10 feet."
    },
    {
    name: "Armored Kilt",
    type: "clothing",
    armorBonus: "3",
    hardness:0,
    maxDex: "2",
    armorCheck: "-4",
    special:"Your movement speed is reduced by 5 feet.",
    rarity:"none",
    },
    {
    name: "Pocket Charm",
    type: "clothing",
    armorBonus: "0",
    hardness:1,
    maxDex: "-",
    armorCheck: "-",
    special:"When an attack by a weapon would kill you or is a critical hit you can destroy this item and instead be reduced to -1 hit points, or roll the damage as a regular hit respectively. The DC for repairing this item goes up by 5 permanently after using this ability, and this item does not repair at the end of each floor.",
    rarity:"none",
    },
    {
    name: "Bandolier",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"You can store 3 items on your Bandolier (after drawing them normally). Retrieving an item stored on your bandolier is a swift action that does not provoke attacks of opportunity. At the end of a floor you can also add a single item from your gear to your bandolier.",
    rarity:"none",
    },
    {
    name: "Nike's",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"While in medium or lighter armor you gain 10 feet to your land movement speed, in heavy you gain 5.",
    rarity:"none",
    },
    {
    name: "Hiking Boots",
    type: "clothing",
    armorBonus: "0",
    hardness:2,
    maxDex: "-",
    armorCheck: "-",
    special:"You can ignore 5 feet of difficult terrain and the negative effects from walking on that surface each round while moving.",
    rarity:"none",
    },
    {
    name: "Heelys",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"Running does not cause you to become flat-footed, and while running can move 5x your speed no matter what armor you are wearing or if an affect is slowing your movement speed, and can make one 90 degree turn while running. However while using this ability you cannot go over difficult terrain or terrain that would slow you, or make any kind of acrobatics checks. You have to be running on the ground to use heelys.",
    rarity:"none",
    },
    {
    name: "Silk Underwear",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"Increase the maximum dexterity bonus of armor by 3, and reduce it's armor check penalty by 1",
    rarity:"none",
    },
    {
    name: "Black Air Force 1's",
    type: "clothing",
    armorBonus: "0",
    hardness:0,
    maxDex: "-",
    armorCheck: "-",
    special:"While charging gain +2 to attack and increase base movement speed by 5 feet, but gain an additional -2 to AC until the start of your next turn.",
    rarity:"none",
    },
    {
    name: "Load Bearing Pants",
    type: "clothing",
    armorBonus: "1",
    hardness:0,
    maxDex: "3",
    armorCheck: "-4",
    special:"If your armor would reduce your movement speed, reduce that reduction by 5 feet. If its medium armor, reduce the penalty by 10 feet.",
    rarity:"none",
    },
    {
    name: "Haramaki",
    type: "light",
    armorBonus: "1",
    hardness:0,
    maxDex: "-",
    armorCheck: "0",
    rarity:"rare",
    },
    {
    name: "Padded",
    type: "light",
    armorBonus: "1",
    hardness:0,
    maxDex: "20",
    armorCheck: "0",
    rarity:"common",
    },
    {
    name: "Lamellar Cuirass",
    type: "light",
    armorBonus: "2",
    hardness:2,
    maxDex: "8",
    armorCheck: "0",
    rarity:"common",
    },
    {
    name: "Rosewood",
    type: "light",
    armorBonus: "2",
    hardness:5,
    maxDex: "14",
    armorCheck: "0",
    rarity:"common",
    },
    {
    name: "Studded Leather",
    type: "light",
    armorBonus: "3",
    hardness:2,
    maxDex: "12",
    armorCheck: "-1",
    rarity:"rare",
    },
    {
    name: "Chain Shirt",
    type: "light",
    armorBonus: "4",
    hardness:10,
    maxDex: "10",
    armorCheck: "-2",
    rarity:"rare",
    },
    {
    name: "Spider Silk",
    type: "light",
    armorBonus: "3",
    hardness:2,
    maxDex: "12",
    armorCheck: "-1",
    special:"Gain a +4 bonus to climb checks",
    rarity:"rare",
    },
    {
    name: "Mithral Chain Shirt",
    type: "light",
    armorBonus: "4",
    hardness:15,
    maxDex: "12",
    armorCheck: "0",
    rarity:"epic",
    },
    {
    name: "Dragon Hide",
    type: "light",
    armorBonus: "5",
    hardness:10,
    maxDex: "15",
    armorCheck: "-2",
    rarity:"legendary",
    },
    {
    name: "Hell Knight Leather",
    type: "light",
    armorBonus: "6",
    hardness:2,
    maxDex: "8",
    armorCheck: "-2",
    rarity:"epic",
    },
    {
    name: "Temporal Leather",
    type: "light",
    armorBonus: "3",
    hardness:2,
    maxDex: "-",
    armorCheck: "-",
    special:"You can move up 10 feet once per round as a free action. This movement provokes as normal. The movement distance increases by 5 feet per enhancement bonus.",
    rarity:"unique",
    },
    {
    name: "Plate Leather",
    type: "light",
    armorBonus: "10",
    hardness:10,
    maxDex: "10",
    armorCheck: "-3",        
    rarity:"unique",
    },
    {
    name: "Barbarian's Fur",
    type: "light",
    armorBonus: "2",
    hardness:2,
    maxDex: "-",
    armorCheck: "-",     
    special:"This armor cannot provide any armor bonus (even with enchantments and abilities), instead it is all converted as an enhancement bonus to your strength score. It cannot provide a larger bonus to your strength score than 3 + 2x the total amount of enchantments",   
    rarity:"unique",
    },
    {
    name: "Kinetic Coat",
    type: "light",
    armorBonus: "5",
    hardness:10,
    maxDex: "12",
    armorCheck: "-",
    special:"When you move (except through teleportation) gain +1 dodge bonus to AC for each 10 feet you moved for 1 round.",
    rarity:"unique",
    },
    {
    name: "Armor Coat",
    type: "medium",
    armorBonus: "4",
    hardness:10,
    maxDex: "4",
    armorCheck: "-2",
    rarity:"common",
    },
    {
    name: "Chain Coat",
    type: "medium",
    armorBonus: "4",
    hardness:10,
    maxDex: "7",
    armorCheck: "-2",
    rarity:"rare",
    },
    {
    name: "Hide",
    type: "medium",
    armorBonus: "4",
    hardness:2,
    maxDex: "6",
    armorCheck: "-3",
    special:"Armor Check Penalty is added as a bonus to stealth checks instead of as a penalty",
    rarity:"rare",
    },
    {
    name: "Kikko",
    type: "medium",
    armorBonus: "5",
    hardness:2,
    maxDex: "6",
    armorCheck: "-3",
    rarity:"rare",
    },
    {
    name: "Breastplate",
    type: "medium",
    armorBonus: "6",
    hardness:10,
    maxDex: "4",
    armorCheck: "-4",
    rarity:"rare",
    },
    {
    name: "Agile Breastplate",
    type: "medium",
    armorBonus: "6",
    hardness:10,
    maxDex: "7",
    armorCheck: "-3",
    rarity:"epic",
    },
    {
    name: "Horn Lamellar",
    type: "medium",
    armorBonus: "5",
    hardness:2,
    maxDex: "4",
    armorCheck: "-4",
    rarity:"common",
    },
    {
    name: "Steel Lamellar",
    type: "medium",
    armorBonus: "9",
    hardness:10,
    maxDex: "3",
    armorCheck: "-5",
    rarity:"legendary",
    },
    {
    name: "Dragon Mail",
    type: "medium",
    armorBonus: "8",
    hardness:10,
    maxDex: "8",
    armorCheck: "-3",
    rarity:"legendary",
    },
    {
    name: "Mailmentum",
    type: "medium",
    armorBonus: "8",
    hardness:10,
    maxDex: "8",
    armorCheck: "-3",
    special:"While in combat every time you move 15 feet you gain 1 stack of momentum. You can expend your momentum as a free action before making a melee attack, gaining +1 to attack and damage for each stack of momentum for that attack. These stacks are lost if you leave combat.",
    rarity:"unique",
    },
    {
    name: "Swivel Coat",
    type: "medium",
    armorBonus: "9",
    hardness:10,
    maxDex: "7",
    armorCheck: "-5",
    special:"While charging you do not have to move to the closest space from which you can attack an opponent. You cannot make charge attacks against creatures within your threatened area at the start of your turn this way.",
    rarity:"unique",
    },
    {
    name: "Living Armor",
    type: "medium",
    armorBonus: "5",
    hardness:2,
    maxDex: "10",
    armorCheck: "-3",
    special:"You gain temporary hitpoints equal to this armor's armor bonus at the start of each of your turns. These temporary hit points stack with other temporary hit points but not its own.",
    rarity:"unique",
    },
    {
    name: "Banded Mail",
    type: "heavy",
    armorBonus: "7",
    hardness:10,
    maxDex: "1",
    armorCheck: "-6",
    rarity:"common",
    },        
    {
    name: "Tatami-do",
    type: "heavy",
    armorBonus: "7",
    hardness:10,
    maxDex: "3",
    armorCheck: "-6",
    rarity:"rare",
    },
    {
    name: "Half-Plate",
    type: "heavy",
    armorBonus: "8",
    hardness:10,
    maxDex: "0",
    armorCheck: "-7",
    rarity:"common",
    },
    {
    name: "Agile Half-Plate",
    type: "heavy",
    armorBonus: "8",
    hardness:10,
    maxDex: "1",
    armorCheck: "-6",
    rarity:"common",
    },
    {
    name: "Fullplate",
    type: "heavy",
    armorBonus: "9",
    hardness:10,
    maxDex: "1",
    armorCheck: "-6",
    rarity:"rare",
    },
    {
    name: "Hell Knight Plate",
    type: "heavy",
    armorBonus: "10",
    hardness:10,
    maxDex: "2",
    armorCheck: "-6",
    rarity:"epic",
    },
    {
    name: "Stone Plate",
    type: "heavy",
    armorBonus: "13",
    hardness:8,
    maxDex: "0",
    armorCheck: "-8",
    special:"Reduce base movement speed by an additional 5 feet",
    rarity:"legendary",
    },
    {
    name: "O-yoroi",
    type: "heavy",
    armorBonus: "8",
    hardness:10,
    maxDex: "4",
    armorCheck: "-5",
    rarity:"epic",
    },
    {
    name: "Stone Coat",
    type: "heavy",
    armorBonus: "10",
    hardness:8,
    maxDex: "0",
    armorCheck: "-7",
    special:"Reduce base movement speed by an additional 5 feet",
    rarity:"rare",
    },
    {
    name: "Dragonplate",
    type: "heavy",
    armorBonus: "10",
    hardness:10,
    maxDex: "5",
    armorCheck: "-4",
    rarity:"legendary",
    },
    {
    name: "The Citadel",
    type: "heavy",
    armorBonus: "12",
    hardness:8,
    maxDex: "0",
    armorCheck: "-10",
    special:"As a swift action at the start of your turn you can increase the armor bonus being granted to you by this armor by 25%, but you cannot move or be moved from your current square by any means, including teleportation, no matter the source. You are also flat footed against any attack against you and automatically fail reflex saves. This lasts until the start of your next turn.",
    rarity:"unique",
    },
    {
    name: "Fortress Plate",
    type: "heavy",
    armorBonus: "12",
    hardness:10,
    maxDex: "4",
    armorCheck: "-6",
    special:"You can apply half your armor bonus against touch attacks. Your armor bonus increases by +4 vs critical threats, confirmations and sneak attacks. This can cause an attack that is a critical threat to become a miss even if it would have hit were it not a critical threat.",
    rarity:"unique",
    },
    {
    name: "Walking Cathedral",
    type: "heavy",
    armorBonus: "15",
    hardness:15,
    maxDex: "0",
    armorCheck: "-15",
    special:"Your movement speed is not reduced by this armor, however you can no longer turn while making any kind of movement, or take 5-foot steps. When a creature causes you to make a save you gain a +1 bonus for each alignment step away from them you are.",
    rarity:"unique",
    },
    {
    name: "Buckler",
    type: "shield",
    armorBonus: "1",
    hardness:10,
    maxDex: "-",
    armorCheck: "0",
    special:"Hand is free while this is equipped, however you lose the AC from it while doing anything with the hand, and gain -1 to the attack if using the hand to attack.",
    rarity:"none",
    },
    {
    name: "War Shield",
    type: "shield",
    armorBonus: "1",
    hardness:10,
    maxDex: "-",
    armorCheck: "-4",
    special:"1d8 shield bash as a light weapon, enhancement bonuses to this shield apply to both the shield bonus and as a weapon while bashing.",
    rarity:"none",
    },
    {
    name: "Light Steel Shield",
    type: "shield",
    armorBonus: "1",
    hardness:10,
    maxDex: "-",
    armorCheck: "-1",
    special:"1d3 shield bash as a light weapon",
    rarity:"none",
    },
    {
    name: "Madu",
    type: "shield",
    armorBonus: "1",
    hardness:10,
    maxDex: "-",
    armorCheck: "-2",
    special:"1d3 shield bash as a light weapon, when fighting defensively the attack penalty becomes -2 instead of -4, and reduce combat expertise attack penalty by 1",
    rarity:"none",
    },
    {
    name: "Heavy Steel Shield",
    type: "shield",
    armorBonus: "2",
    hardness:10,
    maxDex: "-",
    armorCheck: "-2",
    special:"1d4 shield bash as a one handed weapon",
    rarity:"none",
    },
    {
    name: "Tower Shield",
    type: "shield",
    armorBonus: "4",
    hardness:5,
    maxDex: "2",
    armorCheck: "-6",
    special:"Reduces attack by 2. As a standard action can be used to provide total cover from a direction instead of providing AC until your next turn.",
    rarity:"none",
    },
    {
    name: "Kite Shield",
    type: "shield",
    armorBonus: "3",
    hardness:5,
    maxDex: "3",
    armorCheck: "-5",
    special:"1d6 shield bash as one handed weapon. You dont lose your shield bonus to AC while shield bashing with this shield. If you gain another ability that does this you gain a +2 shield bonus for 1 round after you shield bash (doesn't stack if you attack multiple times).",
    rarity:"none",
    },
    {
    name: "Defenders Shield",
    type: "shield",
    armorBonus: "1",
    hardness:5,
    maxDex: "-",
    armorCheck: "-2",
    special:"1d3 shield bash as a one handed weapon. Increases the AC bonus while fighting defensively, total defense, or combat expertise by 2",
    rarity:"none",
    },
    {
    name: "Steel Quickdraw Shield",
    type: "shield",
    armorBonus: "1",
    hardness:10,
    maxDex: "-",
    armorCheck: "-2",
    special:"1d3 shield bash as a light weapon. You can don or remove this shield as a swift action.",
    rarity:"none",
    },
    {
    name: "Throwing Shield",
    type: "shield",
    armorBonus: "2",
    hardness:5,
    maxDex: "-",
    armorCheck: "-2",
    special:"1d4 shield bash as a one handed weapon. You can unclasp this shield as a swift action to throw it with a range increment of 20 feet. It lands in the tile you threw it from at the start of your next turn. Enchantments apply to attacks with this shield while throwing it.",
    rarity:"none",
    },
    {
    name: "Caster's Shield",
    type: "shield",
    armorBonus: "1",
    hardness:5,
    maxDex: "-",
    armorCheck: "-4",
    special:"The hand wielding this shield counts as free for casting spells.",
    rarity:"none",
    },
    {
    name: "Great Shield",
    type: "shield",
    armorBonus: "6",
    hardness:5,
    maxDex: "1",
    armorCheck: "-10",
    special:"1d10 shield bash as a two handed weapon. It takes two hands to wield this shield. Abilities that allow you to wield weapons with one hand (that would apply to a two handed blugeoning weapon) work with this shield, even as a shield.",
    rarity:"none",
    },
]